import React from "react";
import { FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { InfoIcon } from "lucide-react";

interface SimplifiedMoneyFieldProps {
  value: string | number;
  onChange: (value: string) => void;
  label: string;
  description?: string;
  required?: boolean;
  videoUrl?: string;
}

export const SimplifiedMoneyField: React.FC<SimplifiedMoneyFieldProps> = ({
  value,
  onChange,
  label,
  description,
  required = false,
  videoUrl
}) => {
  // Formata o valor como moeda
  const formatCurrency = (value: string | number): string => {
    if (!value) return '';
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return '';
    
    return numValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Processa o input para manter apenas números e vírgula
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    // Remove tudo exceto números e vírgula
    const cleanValue = rawValue.replace(/[^\d,]/g, '');
    onChange(cleanValue);
  };

  const displayValue = value ? formatCurrency(value) : '';

  return (
    <div className="w-full">
      <div className="flex items-center mb-2">
        <label className="text-slate-500 font-bold px-2">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
        {description && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger><InfoIcon size={16} className="text-grey-light ml-1" /></TooltipTrigger>
              <TooltipContent>
                <p>{description}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <div className="relative w-full">
        <span className="absolute left-5 top-1/2 transform -translate-y-1/2 text-gray-500">R$</span>
        <Input 
          value={displayValue} 
          onChange={handleChange}
          className="w-full px-12 py-2.5 text-base placeholder:text-grey-light"
          placeholder="0,00"
          required={required}
        />
      </div>
    </div>
  );
}; 